// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Andrews from '../../../Texas/data/counties/Andrews.geo.json'
import Martin from '../../../Texas/data/counties/Martin.geo.json'
import Howard from '../../../Texas/data/counties/Howard.geo.json'
import Loving from '../../../Texas/data/counties/Loving.geo.json'
import Winkler from '../../../Texas/data/counties/Winkler.geo.json'
import Ector from '../../../Texas/data/counties/Ector.geo.json'
import Midland from '../../../Texas/data/counties/Midland.geo.json'
import Glasscock from '../../../Texas/data/counties/Glasscock.geo.json'
import Reeves from '../../../Texas/data/counties/Reeves.geo.json'
import Ward from '../../../Texas/data/counties/Ward.geo.json'
import Crane from '../../../Texas/data/counties/Crane.geo.json'
import Upton from '../../../Texas/data/counties/Upton.geo.json'
import Pecos from '../../../Texas/data/counties/Pecos.geo.json'
import Jeff_Davis from '../../../Texas/data/counties/Jeff_Davis.geo.json'
import Terrell from '../../../Texas/data/counties/Terrell.geo.json'
import Presidio from '../../../Texas/data/counties/Presidio.geo.json'
import Brewster from '../../../Texas/data/counties/Brewster.geo.json'

const counties = {
  Andrews,
  Martin,
  Howard,
  Loving,
  Winkler,
  Ector,
  Midland,
  Glasscock,
  Reeves,
  Ward,
  Crane,
  Upton,
  Pecos,
  Jeff_Davis,
  Terrell,
  Presidio,
  Brewster
}

export default counties
